// Function to check cart total and toggle FSB visibility
function toggleFSBVisibility() {
  const fsbContainer = document.getElementById('fsb_container');
  if (!fsbContainer) return;

  // Get the threshold from theme settings, default to 100 if not set
  const threshold = window.theme.settings.fsb_threshold || 100;

  // Fetch current cart data
  fetch(window.theme.routes.cart || '/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartTotal = cart.total_price / 100; // Convert from cents to dollars
      if (cartTotal < threshold) {
        fsbContainer.style.display = 'none';
      } else {
        fsbContainer.style.display = 'block';
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Run on page load
document.addEventListener('DOMContentLoaded', toggleFSBVisibility);

// Listen for cart updates
document.addEventListener('cart:updated', toggleFSBVisibility);
document.addEventListener('cart:refresh', toggleFSBVisibility); 